<template>
  <div>
    <div class="listContent">
      <div class="searchContent">
        <el-button
          icon="el-icon-plus"
          type="danger"
          @click="openAddBox(activeObj)"
          v-if="userRoleList.indexOf('menu-31f89c034e8748d39c1ac9d6abcd2287')>-1"
          >添加角色</el-button
        >
        <el-button
          type="info"
          @click="deleteSignAll(theCheckObj.roleCode)"
          plain
          v-if="userRoleList.indexOf('menu-31f89c034e8748d39c1ac9d6abcd2287')>-1"
          >删除</el-button
        >
        <span class="searchInputText">角色名称</span>
        <el-input placeholder="请输入角色名称" v-model="search.roleName"></el-input>
        <el-button type="danger" @click="doSearch">查找</el-button>
        <el-button type="info" @click="resetSearch" plain>重置</el-button>
      </div>

      <div class="listContain equipmentList">
        <div class="tablelistBody">
          <el-table
            :data="dataList"
            style="width: 100%"
            size="medium"
            v-loading="listLoading"
            :row-key="fieldKey"
            @selection-change="handleSelectionChange"
            ref="tb"
          >
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column
              prop="roleName"
              label="角色"
              width=""
            ></el-table-column>
            <el-table-column
              prop="members"
              label="成员数量"
              width=""
            ></el-table-column>
            <el-table-column
              prop="createDate"
              label="创建时间"
              width=""
            ></el-table-column>

            <el-table-column label="操作" width>
              <template slot-scope="scope">
                <span class="lookMore" @click="openModbox(scope.row)" v-if="userRoleList.indexOf('menu-31f89c034e8748d39c1ac9d6abcd2287')>-1">修改</span>
                <span
                  class="lookMore"
                  @click="
                    setRoleInfo({
                      roleCode: scope.row.roleCode,
                      roleName: scope.row.roleName,
                    })
                  "
                  >权限配置</span
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-pageCover
      class="pageBlock"
      :pageMsg="pageMsg"
      @sizeChange="pageSizeChange"
      @currentChange="currentPageChange"
    ></el-pageCover>

    <el-dialog
      :title="actionName"
      :visible.sync="addModBoxVisible"
      :close-on-click-modal="false"
      width="400px"
    >
      <div class="borderBlock borderPadding addAndEdit">
        <el-form
          :rules="rules"
          :model="modelObj"
          ref="addModForm"
          label-width="100px"
        >
          <el-form-item label="角色名称" required prop="roleName">
            <el-input
              class="longType"
              v-model="modelObj.roleName"
              maxlength="20"
              placeholder="请输入角色名称"
            ></el-input>
          </el-form-item>
          <div style="clear: both"></div>
          </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addModBoxVisible = false">取消</el-button>
        <el-button type="primary" @click="addModSubmit">{{
          actionName
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="actionNameN"
      :visible.sync="officeShow"
      :close-on-click-modal="false"
      width="400px"
      @selection-change="handleSelectionChange"
      :row-key="fieldKey"
    >
      <div class="borderBlock borderPadding addAndEdit">
        <el-tree
          :data="treeList"
          node-key="id"
          ref="maskTree"
          default-expand-all
          accordion
          :filter-node-method="filterNode"
          :expand-on-click-node="false"
          @node-click="handleNodeClickAdd"
          :default-checked-keys="checkedKeys"
        ></el-tree>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
            <el-button @click="officeShow = false">取消</el-button>
            <el-button type="primary" @click="editModSubmit">确定</el-button>
        </span> -->
    </el-dialog>
  </div>
</template>

<script>
import {
  getRoleList,
  editRole as modPut,
  addRole as addPost,
  delRole as delPut,
  // getRoleInfo
} from "../../utils/api";
import roleMixin from "../../utils/roleMixin";
import mixinList from "../../utils/mixinList";
import ElPageCover from "../../components/overall/ElPageCover";
export default {
  name: "app",
  mixins: [roleMixin, mixinList],
  data() {
    return {
      fieldKey: "roleCode",
      fieldRowName: "name",
      arrowList: [
        {
          name: "权限管理",
          path: "",
        },
        {
          name: "",
          path: "",
        },
      ],
      search: {},
      modelObj: {},
      actionName: "",
      treeList: [],
      dataList: [],
      activeObj: "",
      theCheckObj: "",
      officeShow: false,
      checkedKeys: [],
      actionNameN: '',
      roleValue: '',
      restaurants: '',
      pageMsg: {
        pageSize: 10,
        pageNo: 1,
        totalRecords: 0,
      },
      userRoleList: localStorage.getItem("userRoleList")
    };
  },
  computed: {
    rules: function () {
      return {
        name: [{ required: true, message: "必填" }, { trigger: "blur" }],
        userName: [{ required: true, message: "必填" }],
        officeName: [{ required: true, message: "必填" }, { trigger: "blur" }],
        roleName: [{ required: true, message: "必填" }, { trigger: "blur" }],
        email: [{ required: true, message: "必填" }, { trigger: "blur" }],
        phone: [{ required: true, message: "必填" }, { trigger: "blur" }],
      };
    },
  },
  created() {},
  mounted() {
    this.$store.commit("setArrowList", this.arrowList);
    this.getDataList()
  },
  methods: {
    addPost,
    modPut,
    delPut,
    openOffice: function () {
      console.log("111");
      this.actionNameN = "部门选择";
      this.officeShow = true;
    },
    filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
    },
    getDataList: function (params) {
      getRoleList(params).then((res) => {
        console.log(res);
        // let _arr = res.data.content.list.concat([]);

        // let _getDepts = function(list, _depts) {
        //   for (let i = 0; i < list.length; i++) {
        //     let _m = list[i];
        //     _depts.push({
        //       id: _m.officeCode,
        //       label: _m.officeName,
        //       originalData: _m
        //     });

        //     if (Object.prototype.hasOwnProperty.call(_m, "children") && _m.children.length > 0) {
        //       _depts[_depts.length - 1].children = [];
        //       _getDepts(_m.children, _depts[_depts.length - 1].children);
        //     }
        //   }
        // };
        // let _depts = [];
        // _getDepts(_arr, _depts);
        // this.treeList = _depts;
        this.pageMsg = this.pageAssign(res.data.content);
        this.dataList = res.data.content.list;
      });
    },
    handleNodeClickAdd(val){
        console.log(val)
        this.modelObj.officeName = val.label
        this.modelObj.officeCode = val.id
        this.officeShow = false
    },
    handleSelectionChange(selection) {
      console.log(selection);
      this.theCheckObj = selection[0];
      if (selection.length == 0) {
        this.checkedGh = "";
      } else {
        this.checkedGh = selection[0].id;
        this.checkedName = selection[0].sectionName;
        if (selection.length > 1) {
          this.$refs.tb.clearSelection();
          this.$refs.tb.toggleRowSelection(selection.pop());
        }
      }
    },
    roleChange: function(e){
        console.log(e)
        var roleCodeList = []
        var getList = this.restaurants
        for(var i=0;i<e.length;i++){
            for(var j=0;j<getList.length;j++){
                if(e[i] == getList[j].roleName){
                    roleCodeList.push(getList[j].roleCode)
                }
            }
        }
        console.log(roleCodeList)
        this.modelObj.roleCode = roleCodeList.join(",")
        this.modelObj.roleName = e.join(",")
    },
    setRoleInfo: function(e,d){
      console.log(e,d)
      // let params = {
      //   roleCode: e.roleCode
      // }
      // getRoleInfo(params).then(res=>{
      //   console.log(res)
      // })
      this.$router.push({path:'/transfer/roleInfo',query:{roleCode:e.roleCode,roleName:e.roleName}})
    }
    
  },
  components: {
    ElPageCover,
  },
};
</script>

<style lang="scss">
// .addAndEdit {
//   .el-input {
//     width: 180px !important;
//     height: 36px !important;
//     margin-left: 23px;
//     margin-right: 23px;
//     font-size: 14px !important;
//     .el-input__inner {
//       width: 180px !important;
//       height: 36px !important;
//       border-radius: 1px !important;
//     }
//   }
// }
</style>
<style lang="scss" scoped="">
.imgShow {
  height: 950px;
  width: 100%;
  background-image: url("../../images/all/applyImg.png");
  background-size: 100% 100%;
}
.listContent {
  height: 790px;
  width: 98.5%;
  margin: 0 auto;
  background-color: #ffffff;
  .searchContent {
    height: 70px;
    width: 80%;
    padding: 17.5px 17px;
  }
}
.listContain {
  width: 98.5%;
  margin: 0 auto;
}
.lookMore {
  display: inline-block;
  font-size: 14px;
  color: #e24747;
  background: rgba(255, 232, 232, 1);
  border: 1px solid rgba(226, 71, 71, 1);
  border-radius: 16px;
  padding: 4px 16px;
  margin-left: 10px;
  cursor: pointer;
}
</style>